<style scoped>
    .staff_table th, .staff_table td {
        height: 32px;
        font-size: 10px;
        padding: 0 4px;
    }

    .info-month-margin-positive{
        font-size: 10px;
        color: green;
    }
    .info-month-margin-negative{
        font-size: 10px;
        color: red;
    }
    .info-col-month-percentage{
        white-space: nowrap;
        background-color: rgba(251, 140, 0, 0.3);
        width: 60px;
        font-weight: bold;
    }
    .info-col-empty-percentage{
        white-space: nowrap;
        width: 60px;
    }
</style>
<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <page-title
                        :title="$t('sales')+' Por Marca'"
                ></page-title>
            </v-col>
            <v-col class="text-right">
                <v-btn small @click="download" color="success">Download</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="6" md="2">
                <v-select
                        v-model="filters.year"
                        label="Ano"
                        :items="years"
                        @change="initialize"
                ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="2" v-if="$writePermission('reports/filters') && salesman.length > 0">
                <v-select
                        v-model="filters.salesman_id"
                        label="Vendedor"
                        :items="salesman"
                        item-text="Nome"
                        item-value="Vendedor"
                        @change="initialize"
                ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="2" v-if="$writePermission('reports/filters') && salesman.length > 0" style="display: flex; align-items: center;">
                <v-btn color="info" @click="showMargin = !showMargin" small>
                    {{showMargin ? 'Esconder Margem' : ' Mostrar Margem'}}
                    <v-icon class="pl-1" v-if="!showMargin" size="18" >mdi-eye</v-icon>
                    <v-icon class="pl-1" v-if="showMargin" size="18" >mdi-eye-off</v-icon>
                </v-btn>
                <v-btn color="warning" @click="showMonthlyPercentage = !showMonthlyPercentage" small class="ml-2">
                    {{showMonthlyPercentage ? 'Esconder % Mensal' : ' Mostrar % Mensal'}}
                    <v-icon class="pl-1" v-if="!showMonthlyPercentage" size="18">mdi-eye</v-icon>
                    <v-icon class="pl-1" v-if="showMonthlyPercentage" size="18">mdi-eye-off</v-icon>
                </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="6" md="2" v-if="$writePermission('reports/filters') && salesman.length > 0" style="display: flex; align-items: center;">
                Clientes:
                <v-btn-toggle
                        v-model="filters.tipoTerceiro"
                        color="red"
                        mandatory
                        variant="outlined"
                        class="ml-1"
                        @change="initialize"
                >
                    <v-btn value="01" small style="background-color: white"><strong>Lojas</strong></v-btn>
                    <v-btn value="03" small style="background-color: white"><strong>Online</strong></v-btn>
                    <v-btn value="01, 03" small style="background-color: white"><strong>Ambos</strong></v-btn>
                </v-btn-toggle>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <div class="staff_v-card">
                    <v-simple-table class="staff_table">
                        <thead>
                        <tr>
                            <th>Marca</th>
                            <th class="text-right" style="background-color: #d9edf7">Janeiro</th>
                            <th class="text-right" style="background-color: #d9edf7" v-if="showMonthlyPercentage  && salesByBrand[salesByBrand.length - 1].JAN != 0">%</th>
                            <th class="text-right">Fevereiro</th>
                            <th class="text-right" v-if="showMonthlyPercentage  && salesByBrand[salesByBrand.length - 1].FEB != 0">%</th>
                            <th class="text-right" style="background-color: #d9edf7">Março</th>
                            <th class="text-right" style="background-color: #d9edf7" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].MAR != 0">%</th>
                            <th class="text-right">Abril</th>
                            <th class="text-right" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].APR != 0">%</th>
                            <th class="text-right" style="background-color: #d9edf7">Maio</th>
                            <th class="text-right" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].MAY != 0" style="background-color: #d9edf7">%</th>
                            <th class="text-right">Junho</th>
                            <th class="text-right" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].JUN != 0">%</th>
                            <th class="text-right" style="background-color: #d9edf7">Julho</th>
                            <th class="text-right" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].JUL != 0" style="background-color: #d9edf7">%</th>
                            <th class="text-right">Agosto</th>
                            <th class="text-right" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].AUG != 0">%</th>
                            <th class="text-right" style="background-color: #d9edf7">Setembro</th>
                            <th class="text-right" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].SEP != 0" style="background-color: #d9edf7">%</th>
                            <th class="text-right">Outubro</th>
                            <th class="text-right" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].OCT != 0">%</th>
                            <th class="text-right" style="background-color: #d9edf7">Novembro</th>
                            <th class="text-right" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].NOV != 0" style="background-color: #d9edf7">%</th>
                            <th class="text-right">Dezembro</th>
                            <th class="text-right" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].DEC != 0">%</th>
                            <th class="text-right" style="background-color: #d9edf7">Total</th>
                            <th class="text-right" style="background-color: #d9edf7">%</th>
                            <th class="text-right" style="background-color: lightgreen" v-if="$writePermission('reports/filters') && salesman.length > 0">Margem</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="loading">
                            <td colspan="27">
                                <v-progress-linear indeterminate></v-progress-linear>
                            </td>
                        </tr>
                        <tr v-for="sale in salesByBrand">
                            <td>{{ sale.CDU_CC }}</td>
                            <td class="text-right" style="white-space: nowrap; background-color: #d9edf7">
                                {{ $money(sale.JAN) }} <br>
                                <span v-if="$writePermission('reports/filters') && salesman.length > 0 && sale.JAN_M != 0 && showMargin" :class="[sale.JAN_M > 0 ? 'info-month-margin-positive' : 'info-month-margin-negative']">({{ $money(sale.JAN_M) }})</span></td>
                            <td class="text-right" :class="[sale.JANP != 0 ? 'info-col-month-percentage' : 'info-col-empty-percentage']" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].JAN != 0">{{  sale.JANP != 0 ? $formatPercentage(sale.JANP) : '0,00 %' }}</td>
                            <td class="text-right" style="white-space: nowrap">
                                {{ $money(sale.FEB) }} <br>
                                <span v-if="$writePermission('reports/filters') && salesman.length > 0 && sale.FEB_M != 0 && showMargin" :class="[sale.FEB_M > 0 ? 'info-month-margin-positive' : 'info-month-margin-negative']">({{ $money(sale.FEB_M) }})</span></td>
                            <td class="text-right" :class="[sale.FEBP != 0 ? 'info-col-month-percentage' : 'info-col-empty-percentage']" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].FEB != 0">{{ $formatPercentage(sale.FEBP) }}</td>
                            <td class="text-right" style="white-space: nowrap; background-color: #d9edf7">
                                {{ $money(sale.MAR) }} <br>
                                <span v-if="$writePermission('reports/filters') && salesman.length > 0 && sale.MAR_M != 0 && showMargin" :class="[sale.MAR_M > 0 ? 'info-month-margin-positive' : 'info-month-margin-negative']">({{ $money(sale.MAR_M) }})</span></td>
                            <td class="text-right" :class="[sale.MARP != 0 ? 'info-col-month-percentage' : 'info-col-empty-percentage']" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].MAR != 0">{{ $formatPercentage(sale.MARP) }}</td>
                            <td class="text-right" style="white-space: nowrap">
                                {{ $money(sale.APR) }} <br>
                                <span v-if="$writePermission('reports/filters') && salesman.length > 0 && sale.APR_M != 0 && showMargin" :class="[sale.APR_M > 0 ? 'info-month-margin-positive' : 'info-month-margin-negative']">({{ $money(sale.APR_M) }})</span></td>
                            <td class="text-right" :class="[sale.APRP != 0 ? 'info-col-month-percentage' : 'info-col-empty-percentage']" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].APR != 0">{{ $formatPercentage(sale.APRP) }}</td>
                            <td class="text-right" style="white-space: nowrap; background-color: #d9edf7">
                                {{ $money(sale.MAY) }} <br>
                                <span v-if="$writePermission('reports/filters') && salesman.length > 0 && sale.MAY_M != 0 && showMargin" :class="[sale.MAY_M > 0 ? 'info-month-margin-positive' : 'info-month-margin-negative']">({{ $money(sale.MAY_M) }})</span></td>
                            <td class="text-right" :class="[sale.MAYP != 0 ? 'info-col-month-percentage' : 'info-col-empty-percentage']" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].MAY != 0" >{{ $formatPercentage(sale.MAYP) }}</td>
                            <td class="text-right" style="white-space: nowrap">
                                {{ $money(sale.JUN) }} <br>
                                <span v-if="$writePermission('reports/filters') && salesman.length > 0 && sale.JUN_M != 0 && showMargin" :class="[sale.JUN_M > 0 ? 'info-month-margin-positive' : 'info-month-margin-negative']">({{ $money(sale.JUN_M) }})</span></td>
                            <td class="text-right" :class="[sale.JUNP != 0 ? 'info-col-month-percentage' : 'info-col-empty-percentage']" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].JUN != 0">{{ $formatPercentage(sale.JUNP) }}</td>
                            <td class="text-right" style="white-space: nowrap; background-color: #d9edf7">
                                {{ $money(sale.JUL) }} <br>
                                <span v-if="$writePermission('reports/filters') && salesman.length > 0 && sale.JUL_M != 0 && showMargin" :class="[sale.JUL_M > 0 ? 'info-month-margin-positive' : 'info-month-margin-negative']">({{ $money(sale.JUL_M) }})</span></td>
                            <td class="text-right" :class="[sale.JULP != 0 ? 'info-col-month-percentage' : 'info-col-empty-percentage']" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].JUL != 0" >{{ $formatPercentage(sale.JULP) }}</td>
                            <td class="text-right" style="white-space: nowrap">
                                {{ $money(sale.AUG) }} <br>
                                <span v-if="$writePermission('reports/filters') && salesman.length > 0 && sale.AUG_M != 0 && showMargin" :class="[sale.AUG_M > 0 ? 'info-month-margin-positive' : 'info-month-margin-negative']">({{ $money(sale.AUG_M) }})</span></td>
                            <td class="text-right" :class="[sale.AUGP != 0 ? 'info-col-month-percentage' : 'info-col-empty-percentage']" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].AUG != 0">{{ $formatPercentage(sale.AUGP) }}</td>
                            <td class="text-right" style="white-space: nowrap; background-color: #d9edf7">
                                {{ $money(sale.SEP) }} <br>
                                <span v-if="$writePermission('reports/filters') && salesman.length > 0 && sale.SEP_M != 0 && showMargin" :class="[sale.SEP_M > 0 ? 'info-month-margin-positive' : 'info-month-margin-negative']">({{ $money(sale.SEP_M) }})</span></td>
                            <td class="text-right" :class="[sale.SEPP != 0 ? 'info-col-month-percentage' : 'info-col-empty-percentage']" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].SEP != 0" >{{ $formatPercentage(sale.SEPP) }}</td>
                            <td class="text-right" style="white-space: nowrap">
                                {{ $money(sale.OCT) }} <br>
                                <span v-if="$writePermission('reports/filters') && salesman.length > 0 && sale.OCT_M != 0 && showMargin" :class="[sale.OCT_M > 0 ? 'info-month-margin-positive' : 'info-month-margin-negative']">({{ $money(sale.OCT_M) }})</span></td>
                            <td class="text-right" :class="[sale.OCTP != 0 ? 'info-col-month-percentage' : 'info-col-empty-percentage']" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].OCT != 0">{{ $formatPercentage(sale.OCTP) }}</td>
                            <td class="text-right" style="white-space: nowrap; background-color: #d9edf7">
                                {{ $money(sale.NOV) }} <br>
                                <span v-if="$writePermission('reports/filters') && salesman.length > 0 && sale.NOV_M != 0 && showMargin" :class="[sale.NOV_M > 0 ? 'info-month-margin-positive' : 'info-month-margin-negative']">({{ $money(sale.NOV_M) }})</span></td>
                            <td class="text-right" :class="[sale.NOVP != 0 ? 'info-col-month-percentage' : 'info-col-empty-percentage']" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].NOV != 0" >{{ $formatPercentage(sale.NOVP) }}</td>
                            <td class="text-right" style="white-space: nowrap">
                                {{ $money(sale.DEC) }} <br>
                                <span v-if="$writePermission('reports/filters') && salesman.length > 0 && sale.DEC_M != 0 && showMargin" :class="[sale.DEC_M > 0 ? 'info-month-margin-positive' : 'info-month-margin-negative']">({{ $money(sale.DEC_M) }})</span></td>
                            <td class="text-right" :class="[sale.DECP != 0 ? 'info-col-month-percentage' : 'info-col-empty-percentage']" v-if="showMonthlyPercentage && salesByBrand[salesByBrand.length - 1].DEC != 0">{{ $formatPercentage(sale.DECP) }}</td>
                            <td class="text-right" style="white-space: nowrap; background-color: #d9edf7">{{ $money(sale.CURRENT_YEAR) }}</td>
                            <td class="text-right" style="white-space: nowrap; background-color: #d9edf7">{{ $formatPercentage(sale.CURRENT_YEARP) }}</td>
                            <td class="text-right" style="white-space: nowrap; font-weight: bold" :style="[parseFloat(sale.MARGEM_YEAR) > 0 ? {'color': 'green'} : {'color': 'red'}]" v-if="$writePermission('reports/filters') && salesman.length > 0">{{ $money(sale.MARGEM_YEAR) }}</td>
                        </tr>
                        </tbody>
                    </v-simple-table>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import i18n from "../../plugins/i18n";

    export default {
        data: () => ({
            loading: false,
            headers: [],
            salesByBrand: [],
            filters: {
                year: new Date().getFullYear(),
                salesman_id: '',
                tipoTerceiro: '01'
            },
            years: [
                new Date().getFullYear(),
                new Date().getFullYear() - 1,
                new Date().getFullYear() - 2,
                new Date().getFullYear() - 3
            ],
            salesman: [],
            showMargin: false,
            showMonthlyPercentage: false,
        }),
        created() {
            document.title = i18n.t('sales') + ' Por Marca'
            this.initialize()
        },
        methods: {
            initialize() {
                this.loading = true
                this.salesByBrand = []
                Reports.dispatch('getSalesByBrand', this.filters)
                    .then(response => {
                        let responseData = response.data
                        if (responseData.status === 'OK') {
                            this.headers = responseData.headers
                            this.salesByBrand = responseData.salesByBrand
                            this.salesman = responseData.salesman
                            this.loading = false
                        } else {
                            this.loading = false
                        }
                    })
                    .catch(response => {
                        this.loading = false
                    })
            },
            download() {
                Reports.dispatch('getSalesByBrandDownload', this.filters)
                        .then(response => {
                            var file = new Blob([response.data], {
                                type: 'application/csv'
                            });
                            var fileURL = URL.createObjectURL(file);
                            var a = document.createElement('a');
                            a.href = fileURL;
                            a.target = '_blank';
                            a.download = 'Report_Sales_Brand_' + this.filters.salesman_id + '_' + this.filters.year + '.csv';
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                        })
                        .catch(response => {

                        })
            },
        }
    }
</script>
